<template>
  <div style="overflow: hidden">
    <apexchart
      ref="subChart"
      height="60%"
      class="mr-2"
      :options="optionsSubChart"
      :series="series"
    ></apexchart>
    <chart-tempo-ressuprimento
      style="height: 20%"
      class="ml-3 mr-2"
      :data="dataRaioX.data"
    ></chart-tempo-ressuprimento>
    <apexchart
      class="ml-3 mr-2"
      height="20%"
      :options="optionsMensal"
      :series="saidas"
      @click="zoomed = false"
    ></apexchart>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProdutoAPI from "../../../api/produto";
import chartTempoRessuprimento from "./ChartTempoRessuprimento";
import { chartPeriodoDinamico, chartMensal } from "./OptionsChart";

export default {
  components: { chartTempoRessuprimento },
  props: ["atualizar", "periodo"],

  data: () => ({
    series: [],
    saidas: [],
    optionsSubChart: chartPeriodoDinamico,
    optionsMensal: chartMensal,
    periodoSel: {},
    escalaMax: 0,
    zoomed: false,
  }),

  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras",
      filialCompra: "usuario/getFilialCompras",
      getFornecedor: "fornecedor/getFornecedor",
      detalhesProduto: "detalhe_produto/getProduto",
      dataRaioX: "chartRaioX/getRaioX",
    }),
  },

  watch: {
    atualizar() {
      if (this.atualizar) {
        this.getSeries();
      }
    },
    periodo: function () {
      if (this.periodo < 13) {
        this.setSelection();
      } else {
        this.setSelection(true);
        this.setChartMensal();
      }
    },
    detalhesProduto() {
      this.$store.dispatch("chartRaioX/resetChart");
    },
    getFornecedor() {
      this.$store.dispatch("chartRaioX/resetChart");
    },
    filialCompra() {
      this.$store.dispatch("chartRaioX/resetChart");
    },
    grupoCompra() {
      this.$store.dispatch("chartRaioX/resetChart");
    },
  },

  created() {
    this.getSeries();
  },

  destroyed() {
    this.$store.dispatch("chartRaioX/resetChart");
    this.$store.dispatch("loadingAux/habilitarLoading", false);
  },

  methods: {
    setSelection(mensal = false) {
      if (this.periodo > 0) {
        this.zoomed = false;
        const xaxis = this.getMesesLabels(this.dataRaioX.data, mensal);

        this.optionsMensal = {
          chart: {
            selection: {
              enabled: true,
              type: "x",
              xaxis: xaxis,
            },
          },
        };
      }
    },
    getMesesLabels: function (data, mensal = false) {
      const length = data.diario.referencias.length - 1;
      const length_mensal = data.mensal.referencias.length - 1;

      let min = "";

      if (this.periodo == 13 || mensal) {
        min = data.mensal.referencias[0];
      } else if (data.diario.referencias[length - this.periodo * 30]) {
        min = data.diario.referencias[length - this.periodo * 30];
      } else {
        min = data.diario.referencias[0];
      }

      const max = data.mensal.referencias[length_mensal];

      return {
        min: new Date(min + " 23:54").getTime(),
        max: new Date(max + " 23:54").getTime(),
      };
    },

    montaSeries: function (data) {
      const {
        estoque,
        entradas,
        saidas,
        esseg,
        ppd,
        emax,
        cmm,
        referencias,
      } = data;

      let series_chart = [
        {
          name: "Estoque",
          type: "area",
          color: "#999",
          data: estoque[0],
          name_data: "estoque",
        },
        {
          name: "Saidas",
          type: "column",
          color: "#DF0101",
          data: saidas[0],
          name_data: "saidas",
        },
        {
          name: "Entradas",
          type: "column",
          color: "#042333",
          data: entradas[0],
          name_data: "entradas",
        },
        {
          name: "Estoque Segurança",
          type: "area",
          color: "#0040FF",
          data: esseg[0],
          name_data: "esseg",
        },
        {
          name: "Ponto de Pedido",
          type: "line",
          color: "#04B431",
          data: ppd[0],
          name_data: "ppd",
        },
        {
          name: "Estoque Máximo",
          type: "line",
          color: "#D7DF01",
          data: emax[0],
          name_data: "emax",
        },
        {
          name: "Projeção de vendas",
          type: "line",
          color: "#8A0868",
          data: cmm[0],
          name_data: "cmm",
        },
      ];

      chartPeriodoDinamico.labels = referencias[0];

      this.optionsSubChart = {
        labels: chartPeriodoDinamico.labels,
      };

      this.series = series_chart;

      if (referencias.length > 1) {
        let index = 1;

        let interval = setInterval(() => {
          if (index == referencias.length) {
            this.$store.dispatch("loadingAux/habilitarLoading", false);
            clearInterval(interval);
          } else {
            this.$refs.subChart.appendData([
              { data: estoque[index] },
              { data: saidas[index] },
              { data: entradas[index] },
              { data: esseg[index] },
              { data: ppd[index] },
              { data: emax[index] },
              { data: cmm[index] },
            ]);

            chartPeriodoDinamico.labels = chartPeriodoDinamico.labels.concat(
              referencias[index]
            );

            this.optionsSubChart = {
              labels: chartPeriodoDinamico.labels,
            };

            index++;
          }
        }, 500);
      } else {
        this.$store.dispatch("loadingAux/habilitarLoading", false);
      }
    },

    setSubChartSobDemanda: function (data) {
      this.$store.dispatch("loadingAux/habilitarLoading", true);

      const { min, max } = this.periodoSel;
      const { referencias } = data;

      const dataSel = {
        referencias: [],
        estoque: [],
        entradas: [],
        saidas: [],
        esseg: [],
        ppd: [],
        emax: [],
        cmm: [],
      };

      this.escalaMax = 0;

      let parte = 0;
      let i = 0;

      referencias.forEach((date, index) => {
        if (this.time(date) > min && this.time(date) < max) {
          // se nao existir, crie
          if (!dataSel.referencias[parte]) {
            dataSel.referencias[parte] = [];
            dataSel.estoque[parte] = [];
            dataSel.saidas[parte] = [];
            dataSel.entradas[parte] = [];
            dataSel.esseg[parte] = [];
            dataSel.ppd[parte] = [];
            dataSel.emax[parte] = [];
            dataSel.cmm[parte] = [];
          }

          dataSel.referencias[parte].push(date);
          dataSel.estoque[parte].push(data.estoque[index]);
          dataSel.saidas[parte].push(data.saidas[index]);
          dataSel.entradas[parte].push(data.entradas[index]);
          dataSel.esseg[parte].push(data.esseg[index]);
          dataSel.ppd[parte].push(data.ppd[index]);
          dataSel.emax[parte].push(data.emax[index]);
          dataSel.cmm[parte].push(data.cmm[index]);

          if (this.escalaMax < parseInt(data.ppd[index])) {
            this.escalaMax = parseInt(data.ppd[index]);
          }

          // divide vetores em partes de 180 posições
          if (i >= 180) {
            parte++;
            i = 0;
          }

          i++;
        }
      });

      this.montaSeries(dataSel);
    },

    setChartMensal: function () {
      const {
        estoque,
        entradas,
        saidas,
        esseg,
        ppd,
        emax,
        cmm,
        referencias,
      } = this.dataRaioX.data.mensal;

      const dadosNoPadrao = {
        estoque: [estoque],
        entradas: [entradas],
        saidas: [saidas],
        esseg: [esseg],
        ppd: [ppd],
        emax: [emax],
        cmm: [cmm],
        referencias: [referencias],
      };

      this.montaSeries(dadosNoPadrao);
    },

    time: function (date) {
      return new Date(date).getTime();
    },

    setChartSaidasMensal: function (data) {
      this.saidas = [
        {
          name: "Saidas",
          color: "#DF0101",
          type: "area",
          data: data.saidas,
        },
      ];

      this.optionsMensal = {
        labels: data.referencias,

        chart: {
          selection: {
            enabled: true,
            type: "x",
            xaxis: this.getMesesLabels(this.dataRaioX.data),
          },
          events: {
            selection: (event, { xaxis }) => {
              if (
                xaxis.min > 0 &&
                xaxis.max > 0 &&
                (xaxis.min != this.periodoSel.min ||
                  xaxis.max != this.periodoSel.max)
              ) {
                clearTimeout(this.interval);
                this.interval = setTimeout(() => {
                  this.periodoSel = xaxis;
                  this.$emit("periodo", this.periodoSel);
                  this.$emit("zerarPeriodo");

                  if (!this.zoomed && this.periodo < 13) {
                    this.setSubChartSobDemanda(this.dataRaioX.data.diario);
                  } else {
                    this.setSelection(true);
                    this.setChartMensal();
                  }
                }, 400);
              }
            },
          },
        },
      };
    },

    setEventZoomed() {
      this.optionsSubChart = {
        chart: {
          events: {
            zoomed: (chartContext, { xaxis }) => {
              this.zoomed = true;
              this.$emit("zerarPeriodo");

              const labels = this.optionsSubChart.labels;

              const newXaxis = {
                min: new Date(labels[xaxis.min - 1] + " 23:54").getTime(),
                max: new Date(labels[xaxis.max - 1] + " 23:54").getTime(),
              };

              // quando é resetado o zoom
              const newXaxisTotal = {
                min: new Date(labels[0] + " 23:54").getTime(),
                max: new Date(labels[labels.length - 1] + " 23:54").getTime(),
              };

              this.optionsMensal = {
                chart: {
                  selection: {
                    enabled: true,
                    type: "x",
                    xaxis: newXaxis.min ? newXaxis : newXaxisTotal,
                  },
                },
              };
            },
          },
        },
      };
    },

    getSeries: function () {
      const { data } = this.dataRaioX;

      if (data.referencias.length > 0) {
        this.setChartSaidasMensal(data.mensal);
      } else {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          grupo: this.detalhesProduto.id_grupo,
          filial: this.filialCompra,
          produto: this.detalhesProduto.idproduto,
          produtos: this.detalhesProduto.produtos || [],
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          ProdutoAPI.getRaioXProdutoChart(headers, params)
            .then((response) => {
              let { raio_x, token } = response.data;
              localStorage.setItem("token", token);
              this.$store.dispatch("chartRaioX/setData", raio_x);

              this.setChartSaidasMensal(raio_x.mensal);
              this.setEventZoomed();
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },
  },
};
</script>
